<template>
  <v-card
    class="detail-container"
    v-if="item"
    flat>
    <div
      v-for="(value, key) in groups"
      :key="key">
      <div class="row">
        <div class="group">
          <div
            v-for="(field, index) in value"
            :key="index"
            class="property"
            :class="{ 'label-top': field.labelPosition === 'top', 'label-left': field.labelPosition !== 'top' && field.labelPosition !== 'hidden' }">
            <label
              class="property-label"
              v-if="field.labelPosition !== 'hidden'">
              {{ field.label }}
              <span v-if="isArray(item[field.name])">
                <template v-if="field.filter">
                  ({{ item[field.name].filter(field.filter).length }})
                </template>
                <template v-else>
                  ({{ item[field.name].length }})
                </template>
              </span>
              <span v-else-if="item[field.name] && item[field.name].totalElements">
                <template>({{ item[field.name].totalElements }})</template>
              </span>
              <span v-if="field.required && editionMode">
                (*)
              </span>
            </label>
            <div class="property-content">
              <component
                :value.sync="item[field.name]"
                :schema="schema"
                :field="field"
                :item="item"
                :is="field.component" />
            </div>
          </div>
        </div>
        <div
          class="edit-column"
          v-if="!editMode && hideEditBtn !== true && value.find(i => !i.readonly)">
          <v-btn
            class="edit-btn"
            title="edit item"
            v-if="canManage"
            @click="editGroup(key)"
            icon
            small>
            <v-icon small>
              fas fa-pen
            </v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider />
    </div>
  </v-card>
</template>

<script>
import { groupBy, isArray } from 'lodash'
import { mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    schema: {
      type: Object,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    group: {
      type: String,
      default: null
    },
    hideEditBtn: {
      type: Boolean,
      default: false
    },
    displayIn: {
      type: String,
      default: 'detail'
    }
  },
  computed: {
    canManage () {
      return this.schema && this.schema.canManage()
    },
    editionMode () {
      return this.schema && this.editMode && this.canManage
    },
    detailFields () {
      return this.editionMode ? this.schema.editIn(this.displayIn) : this.schema.displayIn(this.displayIn)
    },
    filteredDetailFields () {
      return this.group ? this.detailFields.filter(df => df.group === this.group) : this.detailFields
    },
    groups () {
      return this.filteredDetailFields && groupBy(this.filteredDetailFields, 'group')
    }
  },
  methods: {
    ...mapActions('schema-view', [
      'editDefinition'
    ]),
    isArray,
    editGroup (group) {
      this.editDefinition({
        schema: this.schema,
        item: this.item,
        group
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "~common-assets/scss/we";

  .detail-container {
    padding: 5px;
    font-size: 15px;
    font-weight: 400;
    overflow: auto;
    .row {
      @include flex-row;
      overflow: hidden;
    }
    .group {
      width: 100%;
    }

    .v-input {
      margin: 0;
      padding: 0;
    }

    .edit-btn {
      margin: 0;
      z-index: 99;
      right: 5px;
      position: absolute;
    }

    .property {
      padding: 5px 0;
      &.label-left {
        @extend .flex-row;
      }

      &.label-top {
        @extend .flex-column;
      }

      .property-label {
        min-width: 100px;
        font-size: 14px;
        color: rgba(115, 115, 115, 0.67);
        vertical-align: text-top;
        margin-top: 5px;
        @include media-breakpoint-up(md) {
          min-width: 180px;
        }
      }
      .property-content {
        width: 100%;
        padding: 2px 5px;
        position: relative;
        margin: auto;
        @extend .text-no-wrap;
      }
    }
  }
</style>
